import IconTextSize from "../../../public/images/text-size.svg";
import Field from "../../Field";
import {useEffect, useRef} from "react";
import Select from "./Select";
import ArrowButtonInput from "../buttons/ArrowButtonInput";
import SelectListComponent from "./SelectListComponent";
import {fontSizeVariants} from "../../../utils/consts";
import useObjectEditStore from "../../../store/useObjectEditStore";
import {decrement} from "../../../utils/decrement";
import {increment} from "../../../utils/increment";
import PropTypes from "prop-types";

const SizeSelect = () => {
  return (
    <Select tab='size' buttonContent={<IconTextSize className="select__icon"/>}>
      <ListComponent variants={fontSizeVariants}/>
    </Select>
  );
};

const ListComponent = ({variants}) => {
  const objectEditStore = useObjectEditStore();
  const inputRef = useRef(null);

  useEffect(() => {
    const objectEdit = () => {
      const element = objectEditStore.objectEdit.element;
      if (element) {
        element.style.fontSize = objectEditStore.fontSize + 'px';
        const controls = element.querySelector('.obj-controls');
        if (controls){
          controls.style.display = 'none';
          controls.style.height = element.scrollHeight + 'px';
          controls.style.width = element.scrollWidth + 'px';
          controls.style.display = 'block';
        }
        return {
          ...objectEditStore.objectEdit,
          size: objectEditStore.fontSize,
        };
      }
      return objectEdit
    }
    objectEditStore.setObjectEdit(objectEdit());
  }, [objectEditStore.fontSize])

  return (
    <SelectListComponent tab='size' setState={objectEditStore.setFontSize} state={objectEditStore.fontSize} variants={variants} className='select__variant-size'>
      <div className="select__input-block">
        <Field.Input
          type="number" value={objectEditStore.fontSize} ref={inputRef}
          onChange={(event) => objectEditStore.setFontSize(event.target.value)}
          onClick={(event) => event.stopPropagation()}
          min="1" max="999" autoComplete="off"
          className="select__input"
        />
        <ArrowButtonInput onClick={() => objectEditStore.setFontSize(decrement({ref: inputRef}))} isBottom={false}/>
        <ArrowButtonInput onClick={() => objectEditStore.setFontSize(increment({ref: inputRef}))} isBottom={true}/>
      </div>
    </SelectListComponent>
  )
}

ListComponent.propTypes = {
  variants: PropTypes.array,
};

export default SizeSelect;
